import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { ncFileDetailsNCFileConfig } from './config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const NCFileDetailsNCFileStack = createStackNavigator();

const NCFileDetailsNCFileNavigator = () => {
  return (
    <NCFileDetailsNCFileStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {ncFileDetailsNCFileConfig.map(({ Component, name }) => (
        <NCFileDetailsNCFileStack.Screen key={name} name={name} component={Component} />
      ))}
    </NCFileDetailsNCFileStack.Navigator>
  );
};

export { NCFileDetailsNCFileNavigator };
